(function () {
  'use strict';

  class LBPLightbox extends HTMLElement {
    static observedAttributes = ["url"];

    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
      this.markup = `
    <div class="lightbox-container" aria-label="Dialog Window (press escape to close)" role="dialog" tabindex="-1" aria-hidden="true">
      <div class="close">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </div>
      <div class="lightbox-content">
        <div class="lightbox-content-inner"></div>
      </div>
    </div>
  `;
      this.css = `
    <style>
      .lightbox-container {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        display: none;
      }
      .lightbox-container.is-visible {
        display: block;
      }
      .close {
        position: absolute;
        top: 10px;
        right: 10px;
        width: 40px;
        cursor: pointer;
        color: white;
      }
      .lightbox-content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: white;
        padding: 20px;
        border-radius: 8px;
        max-width: 90%;
        max-height: 90%;
        overflow: auto;
      }
      .overflow-hidden {
        overflow: hidden;
      }
    </style>
  `;
    }

    connectedCallback() {
      this.shadowRoot.innerHTML = `${this.css}${this.markup}`;
      this.addEventListeners();
    }

    disconnectedCallback() {
      this.removeEventListeners();
    }

    addEventListeners() {
      const closeButton = this.shadowRoot.querySelector('.close');
      const lightboxContainer = this.shadowRoot.querySelector('.lightbox-container');

      if (closeButton) {
        closeButton.addEventListener('click', this.closeLightbox.bind(this));
      }

      if (lightboxContainer) {
        lightboxContainer.addEventListener('click', (e) => {
          if (e.target === e.currentTarget) {
            this.closeLightbox();
          }
        });
      }
    }

    removeEventListeners() {
      const closeButton = this.shadowRoot.querySelector('.close');
      const lightboxContainer = this.shadowRoot.querySelector('.lightbox-container');

      if (closeButton) {
        closeButton.removeEventListener('click', this.closeLightbox.bind(this));
      }

      if (lightboxContainer) {
        lightboxContainer.removeEventListener('click', this.closeLightbox.bind(this));
      }
    }

    showLightbox() {
      const lightboxContainer = this.shadowRoot.querySelector('.lightbox-container');
      if (lightboxContainer) {
        lightboxContainer.setAttribute('aria-hidden', 'false');
        lightboxContainer.classList.add('is-visible');
        document.body.classList.add('overflow-hidden');
      }
    }

    closeLightbox() {
      const lightboxContainer = this.shadowRoot.querySelector('.lightbox-container');
      if (lightboxContainer) {
        lightboxContainer.setAttribute('aria-hidden', 'true');
        lightboxContainer.classList.remove('is-visible');
        document.body.classList.remove('overflow-hidden');
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      console.log("attr changed", name, oldValue, newValue);
      if (name === 'url' && newValue) {
        this.displayVideo(newValue);
        this.showLightbox();
      }
    }

    displayVideo(url) {
      const contentInner = this.shadowRoot.querySelector('.lightbox-content-inner');
      if (contentInner) {
        const isDesktop = window.innerWidth > 1400;
        const width = isDesktop ? '60vw' : '80vw';
        const height = isDesktop ? '33.75vw' : '60vh';

        contentInner.innerHTML = `
      <iframe src="${url}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen style="width: ${width}; height: ${height};"></iframe>
    `;
      }
    }
  }

  class PDPMainCarousel extends HTMLElement {
    constructor() {
      super();
      this.mainCarousel = null;
      this.mainSlides = null;
      this.thumbnailCarousel = null;
      this.thumbnailSlides = null;
      this.sliderDots = null;
      this.currentSlideIndex = 0;
    }

    connectedCallback() {

      this.initMainCarousel();
      this.initThumbnailCarousel();
      this.initSliderDots();
      this.syncCarousels();
    }

    maxChildHeight() {
      const slides = this.querySelectorAll('.product-images__item');
      let maxHeight = 0;

      slides.forEach((slide) => {
        if (slide.offsetHeight > maxHeight) {
          maxHeight = slide.offsetHeight;
        }
      });

      return `${maxHeight}px`;
    }

    initMainCarousel() {
      this.mainCarousel = this.querySelector('[data-product-image-carousel]');
      this.mainSlides = this.mainCarousel.querySelectorAll('.product-images__item');

      // this causes ugly reflow, consider refactoring main carousel to not be stacked absolute positioned children so we can let container
      // determine height naturally
      //this.mainCarousel.style.height = this.maxChildHeight();

      this.updateMainCarousel();
    }

    updateMainCarousel() {
      this.mainSlides.forEach((slide, index) => {
        if (this.currentSlideIndex === index) {
          slide.classList.add('active');
        } else {
          slide.classList.remove('active');
        }
      });
    }

    initThumbnailCarousel() {
      this.thumbnailCarousel = this.querySelector('[data-product-thumbnail-carousel]');
      this.thumbnailSlides = this.thumbnailCarousel.querySelectorAll('.product-thumbnails__item');

      this.thumbnailSlides.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => {
          this.currentSlideIndex = index;

          // vertical scroll on desktop
          if (window.innerWidth < 768) {
            const scrollOffset = Number(window.getComputedStyle(thumbnail.parentElement).marginLeft.split('px')[0]);
            this.thumbnailCarousel.scrollTo({ left: thumbnail.offsetLeft - scrollOffset, behavior: 'smooth' });
          } else {
            thumbnail.parentElement.scrollTo({ top: thumbnail.offsetTop, behavior: 'smooth' });
          }

          this.updateMainCarousel();
          this.updateThumbnailCarousel();
          this.updateSliderDots();
        });
      });

      this.updateThumbnailCarousel();
    }

    updateThumbnailCarousel() {
      this.thumbnailSlides.forEach((thumbnail, index) => {
        thumbnail.classList.toggle('active', index === this.currentSlideIndex);
      });
    }

    initSliderDots() {
      this.sliderDots = this.querySelector('[data-product-slider-dots]');
      this.sliderDotsElements = this.sliderDots.querySelectorAll('.product-slider-dots__item');

      this.sliderDotsElements.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.currentSlideIndex = index;

          this.updateMainCarousel();
          this.updateThumbnailCarousel();
          this.updateSliderDots();
        });
      });

      this.updateSliderDots();
    }

    updateSliderDots() {
      this.sliderDotsElements.forEach((dot, index) => {
        dot.classList.toggle('active', index === this.currentSlideIndex);
      });
    }

    syncCarousels() {
      this.updateMainCarousel();
      this.updateThumbnailCarousel();
      this.initSliderDots();
    }
  }

  customElements.define('lbp-lightbox', LBPLightbox);
  customElements.define('pdp-main-carousel', PDPMainCarousel);

})();
